import { useEffect, useState } from "react";
import api from "@/lib/api";

// Fetches published product ratings once and returns a map { product_id: {average, count} }.
export default function useProductRatings() {
  const [map, setMap] = useState({});
  useEffect(() => {
    api.get("/product-ratings").then((r) => {
      const m = {};
      (r.data || []).forEach((x) => { m[x.product_id] = { average: x.average, count: x.count }; });
      setMap(m);
    }).catch(() => {});
  }, []);
  return map;
}
